import { render, staticRenderFns } from "./bannerBox.vue?vue&type=template&id=c63125b0&scoped=true&"
import script from "./bannerBox.vue?vue&type=script&lang=js&"
export * from "./bannerBox.vue?vue&type=script&lang=js&"
import style0 from "./bannerBox.vue?vue&type=style&index=0&id=c63125b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c63125b0",
  null
  
)

export default component.exports